// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__GLbXh","accent":"Tag_accent__GW288"};